import React, { useState, useEffect, useContext, useMemo,  } from "react";
import getAjax from "../js/utilities/getAjax";
import { GENERAL_URL_API, ASSETS_URL } from "../components/Store.js";
import { AccesibilidadContext } from "../contexts/AccesibilidadContext";
import _ from 'lodash'
//Componentes
import Libro from "../components/Libro";
import SkeletonFichaColeccion from "../skeletons/SkeletonFichaColeccion";
import { CollectionBooks } from "./collectionBooks";

import { useHistory } from "react-router-dom";
import { useLanguage } from "../hooks/use-language.js";
import { useUserBooks } from "../hooks/useUserBooks.js";
import { useId } from "../hooks/use-id.js";
import { useTranslationsById } from "../hooks/use-translations-by-id.js";

/**
 * Componente para mostrar la ficha de una colección.
 * @param {object} props - Propiedades del componente.
 * @returns {JSX.Element} Elemento JSX que representa la ficha de la colección.
 */

const FichaColeccion = (props) => {
  const lang = useLanguage();
  const [isLoading, setIsloading] = useState(true);
  const [datosColeccion, setDatosColeccion] = useState({});
  const [librosColeccion, setLibrosColeccion] = useState([]);
  const userBooks = useUserBooks();
  // los libros de librosColeccion no traen titulo, entonces los traemos de userBooks
  const books = useMemo(() => {
    const _books = userBooks.books.filter(book => librosColeccion.some(libro => libro.idLibro === book.idLibro));
    const randomOrder = _.shuffle(_books);
    return randomOrder;
    
  },[librosColeccion, userBooks.books]);

  const [esTemaClasico, setEsTemaClasico] = useState(true);
  const accebilidadState = useContext(AccesibilidadContext);

  const name = lang==='en'?datosColeccion?.nombreIng || datosColeccion?.nombreColeccion:datosColeccion?.nombreColeccion;
  const description = lang==='en'?datosColeccion?.descripcionIng || datosColeccion?.descripcion:datosColeccion?.descripcion;
  const subtitle = lang==='en'?datosColeccion?.subtituloIng || datosColeccion?.subtitulo:datosColeccion?.subtitulo;

  const history = useHistory(); 

  const coleccionTitleId = useId('coleccion-title');

  const texts = useTranslationsById({ mainSectionName: "ficha_coleccion", language: lang });

  useEffect(() => {
    let id = props.match.params.nombreColeccion;
    getAjax(
      `${GENERAL_URL_API}/assets/datosColeccion`,
      { nombreColeccion: id },
      (response) => {
        try {
          let data = Boolean(response) ? JSON.parse(response) : {};
          const books = Array.isArray(data.libros)?data.libros:[];
          // evitar libros duplicados.
          const ids = new Set();
          const filteredBooks = books.filter(book => {
            if (ids.has(book.idLibro)) return false;
            ids.add(book.idLibro);
            return true;
          });
          setLibrosColeccion(filteredBooks);
          setDatosColeccion(data);
          setIsloading(false);
        }catch(error){
          console.log('Coleccíon error:',error)
          setIsloading(false);
          setLibrosColeccion([]);
          setDatosColeccion([]);
          history.push('/404')
        }
        
      }
    );
  }, [props.match.params.nombreColeccion]);

  useEffect(() => {
    let tema = accebilidadState?.temaActual !== 'clasico' ? false : true;
    setEsTemaClasico(tema);
  }, [accebilidadState])

  return (
    <>
      {(() => {
        if (isLoading) {
          return <div role="status" aria-live="polite"><SkeletonFichaColeccion /></div>;
        } else {
          return (
            <>
              <section className="focusable-secondary main-container" aria-labelledby={coleccionTitleId}>
                <div
                  className="coleccion-container"
                  style={{
                    backgroundColor: esTemaClasico ? datosColeccion.color1 : 'var(--background-color)',
                    color: esTemaClasico ? datosColeccion.colorLetras : 'var(--onbackground-primary)',
                  }}
                >
                  <div
                    className="coleccion-background"
                    style={{
                      background: `${esTemaClasico ? datosColeccion.color2 : 'var(--background-color)'} url('/img/background.png') center/cover repeat`,
                    }}
                  ></div>
                  <div className="container">
                    <div className="row pt-5 align-items-center mb-3">
                      <div className="col-lg-6 mb-5 mb-lg-0">
                        <h1 className="focusable-secondary" style={{ color: esTemaClasico ? datosColeccion.colorLetras : 'var(--onbackground-primary)' }} id={coleccionTitleId}>
                          {name}
                        </h1>
                      </div>
                      <div className="col-lg-6 pl-lg-5">
                        <p className="coleccion-autor">
                          {subtitle}
                        </p>
                        <p className="focusable-secondary text-18">{description}</p>
                      </div>
                    </div>
                    <div className="row mt-5 pb-5 mt-lg-0 align-items-center">
                      <div className="mb-5 mb-lg-0 col-lg-6 px-0 d-none d-lg-block ">
                        <div className="coleccion-imagen">
                          <img
                            alt="" aria-hidden={true}
                            className="img-fluid mx-auto d-block"
                            src={`${ASSETS_URL}${datosColeccion.imagen}`}
                          />
                        </div>
                      </div>
                      <div
                        className={
                          books?.length <= 6
                            ? "col-lg-6 pl-lg-5"
                            : "col-lg-6 pb-5 pl-lg-4"
                        }
                      >
                        {(() => {
                          if (books?.length <= 6) {
                            return (
                              <ul className="coleccion-books row" aria-label={texts?.getText({id: "collection_books", defaultText:"Libros de la colección"})}>
                                {books.map((item, index) => (
                                  <li
                                    className={`cover-book col-6 col-lg-4 mb-4`}
                                    key={`book${index}`}
                                  >
                                    <Libro
                                      libro={item}
                                      portada={item.portada}
                                      webUrl={item.link}
                                    />
                                  </li>
                                ))}
                              </ul>
                            );
                          } else {
                            return (<CollectionBooks books={books}/>);
                          }
                        })()}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </>
          );
        }
      })()}
    </>
  );
};

export default FichaColeccion;
